import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrushInflateIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 19h20M7 19c0-5 10-5 10 0",
			opacity: .25
		}),
		/* @__PURE__ */ _jsx("path", {
			strokeWidth: 2.2,
			d: "M4 19C4 7 20 7 20 19"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m7 12-2-2M12 8V5M17 12l2-2",
			opacity: .6
		})
	]
});
export default SvgBrushInflateIcon;
